import primaryComponents, {
  AsyncSelectField,
} from "../../../../primaryComponents";
import styles from "./styles.module.scss";
import globalStyles from "../../../../../assets/styles/base/globalPage.module.scss";
import { useGetPurchaseOrdersForSelectField } from "../../../../../hooks/api/queries";
import { useStoreListObject } from "../../../../../hooks/useStoreListObject";

export const BasicInfo = ({
  billsForm,
  pODetails = {},
  isEditMode = false,
  setBillsForm = () => {},
  ...validationParams
}) => {
  const {
    register,
    control,
    formState: { errors },
    trigger,
  } = validationParams;
  const { loadOptions } = useGetPurchaseOrdersForSelectField({
    queryParams: { has_billables: true },
  });
  const { storeMap } = useStoreListObject();

  return (
    <div className={styles.basicInfo}>
      <div className={`${globalStyles.cardWithBorder}`}>
        <div
          className={"d-flex flex-column flex-md-row align-items-center"}
          style={{ columnGap: "50px" }}
        >
          <div className="w-100">
            <AsyncSelectField
              control={control}
              name={"po_id"}
              register={register}
              label={"Select PO"}
              labelDescription="Select a PO number for this Bill"
              isRequired
              value={billsForm?.po_number || undefined}
              nameKey={"name"}
              idKey={"id"}
              loadOptions={loadOptions}
              isDisabled={isEditMode}
              errorMessage={errors?.po_id}
              onChange={(value) => {
                setBillsForm((prevState) => ({
                  ...prevState,
                  po_id: value,
                }));
              }}
            />
          </div>
          <div
            className="d-flex w-100 justify-content-end"
            style={{ columnGap: "50px" }}
          >
            {/* <h5 className="font-weight-normal gray--text">
              <span style={{ fontStyle: "italic" }}>Store: </span>
              <span className="purple--text">
                {pODetails?.store?.name || "N/A"}
              </span>
            </h5> */}

            <h5 className="font-weight-normal gray--text">
              <span style={{ fontStyle: "italic" }}>Supplier: </span>
              <span className="purple--text">
                {pODetails?.supplier?.name || "N/A"}
              </span>
            </h5>
          </div>
        </div>

        {/* invoice section */}
        <div
          className="d-flex flex-column flex-xl-row w-100"
          style={{ columnGap: "15px" }}
        >
          <div className="w-100">
            <primaryComponents.InputFieldV2
              control={control}
              name={"invoice_number"}
              register={register}
              label={"Invoice Number"}
              placeholder={"Enter invoice number"}
              className="white"
              value={billsForm.invoice_number}
              onKeyUp={() =>
                errors?.invoice_number && trigger("invoice_number_quantity")
              }
              onChange={({ target: { value } }) => {
                setBillsForm((prevState) => ({
                  ...prevState,
                  invoice_number: value,
                }));
              }}
            />
          </div>
          <div className="w-100">
            <primaryComponents.DateInputV2
              control={control}
              name={"invoice_date"}
              register={register}
              label={"Invoice Date"}
              placeholder={"Enter invoice date"}
              className="white"
              value={billsForm.invoice_date}
              onChange={({ target: { value } }) => {
                setBillsForm((prevState) => ({
                  ...prevState,
                  invoice_date: value,
                }));
              }}
            />
          </div>
          <div className="w-100">
            <primaryComponents.DateInputV2
              control={control}
              name={"invoice_due_date"}
              register={register}
              label={"Invoice Due Date"}
              placeholder={"Enter invoice due date"}
              className="white"
              value={billsForm.invoice_due_date}
              onChange={({ target: { value } }) => {
                setBillsForm((prevState) => ({
                  ...prevState,
                  invoice_due_date: value,
                }));
              }}
            />
          </div>
          <div className="w-100">
            <primaryComponents.DateInputV2
              control={control}
              name={"invoice_receipt_date"}
              register={register}
              label={"Invoice Receipt Date"}
              placeholder={"Enter receipt date"}
              className="white"
              value={billsForm.invoice_receipt_date}
              onChange={({ target: { value } }) => {
                setBillsForm((prevState) => ({
                  ...prevState,
                  invoice_receipt_date: value,
                }));
              }}
            />
          </div>
          <div className="w-100">
            <primaryComponents.AmountFieldV2
              control={control}
              name={"invoice_amount"}
              register={register}
              label={"Invoice Amount"}
              placeholder={"Enter invoice amount"}
              className="white"
              value={billsForm.invoice_amount}
              currency_code={
                storeMap?.[billsForm?.items?.[0]?.store_id]?.currency_code
              }
              onChange={({ target: { value } }) => {
                setBillsForm((prevState) => ({
                  ...prevState,
                  invoice_amount: value,
                }));
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
